module.exports = __webpack_public_path__ + "media/images/graphic/graphic_error-e43ee99a82e20228e40e6c434947ac8f.png";